import { Component, EventEmitter, HostBinding, HostListener, Input, OnInit, Output } from '@angular/core';

@Component({
    selector: 'app-scroll-list-add-button',
    templateUrl: './scroll-list-add-button.component.html',
    styleUrls: ['./scroll-list-add-button.component.scss']
})
export class ScrollListAddButtonComponent {

    @Input() @HostBinding('class.selected') selected = false;

    @Output() create = new EventEmitter<any>();

    @HostListener('click', ['$event.target'])
    onBatchClick() {
        this.create.emit();
    }

}
